/* eslint-disable */
import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CTitle } from '../../components/Widget';
import { useUpdateComponentState } from '../../../hooks';
import Quiz from '../../components/Quiz';
import WhyStudentTargetReasons from '../../components/WhyStudentTargetReasons';
import PracticeGridCards from '../../components/PracticeGridCards';
import people from '../../../../../../assets/sme/psa/quiz_people.png';

interface Settings {
  paragraphs: any[];
}

interface ISection2Props {
  settings: Settings;
}

const Section3: React.FunctionComponent<ISection2Props> = ({ settings }) => {
  const ID = '4';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = React.useMemo(
    () => settings?.paragraphs[3],
    [settings?.paragraphs]
  );
  const updateComponentState = useUpdateComponentState();
  const [state, setState] = useState({ quiz: false });

  // const handleWhyStudentTargetReasonsComplete = React.useCallback(() => {
  //   updateComponentState(p_course, p_topic, ID, 'student-training-psa-section3-1');
  // }, [updateComponentState, p_course, p_topic, ID]);

  return (
    <div className="topic-section-3">
      <CTitle title={paragraphsSettings?.title ?? ''} />
      <PracticeGridCards
        description={paragraphsSettings?.l4SubTitle}
        items={paragraphsSettings?.l4}
        variant="psa"
      />
      <WhyStudentTargetReasons
        title={''}
        description={paragraphsSettings?.l1SubTitle}
        items={paragraphsSettings?.l1Lists}
      />
      <div id="student-training-psa-section3-question" className="topic-quiz">
        <Quiz
          title={paragraphsSettings?.questionTitle ?? ''}
          description={paragraphsSettings?.quiz?.description ?? ''}
          question={paragraphsSettings?.quiz?.question ?? ''}
          options={paragraphsSettings?.quiz?.options ?? []}
          quizImg={people}
          onCompleted={() => {
            setState({ ...state, quiz: true });
            updateComponentState(
              p_course,
              p_topic,
              ID,
              'student-training-psa-section3-question'
            );
          }}
        />
      </div>
    </div>
  );
};

export default Section3;
